import { Controller } from "@hotwired/stimulus"

import { formatClock } from "@/lib/utils"

export default class extends Controller {
  static targets = [
    "audio",
    "playIcon",
    "pauseIcon",
    "progress",
    "time",
    "idleView",
    "playerView",
  ]
  static values = {
    state: { type: String, default: "idle" },
  }

  declare readonly audioTarget: HTMLAudioElement
  declare readonly playIconTarget: HTMLElement
  declare readonly pauseIconTarget: HTMLElement
  declare readonly progressTarget: HTMLElement
  declare readonly timeTarget: HTMLElement
  declare readonly idleViewTarget: HTMLElement
  declare readonly playerViewTarget: HTMLElement
  declare stateValue: string

  toggle() {
    if (this.stateValue === "idle" || this.stateValue === "paused") {
      void this.audioTarget.play()
      this.stateValue = "playing"
    } else if (this.stateValue === "playing") {
      this.audioTarget.pause()
      this.stateValue = "paused"
    }
  }

  stateValueChanged(state: string) {
    const idle = state === "idle"
    this.idleViewTarget.classList.toggle("hidden", !idle)
    this.playerViewTarget.classList.toggle("hidden", idle)
    this.playerViewTarget.classList.toggle("inline-flex", !idle)

    if (state === "playing") {
      this.playIconTarget.classList.add("hidden")
      this.pauseIconTarget.classList.remove("hidden")
    } else {
      this.playIconTarget.classList.remove("hidden")
      this.pauseIconTarget.classList.add("hidden")
    }
  }

  updateProgress() {
    const audio = this.audioTarget
    if (audio.duration && isFinite(audio.duration)) {
      const pct = (audio.currentTime / audio.duration) * 100
      this.progressTarget.style.width = `${pct}%`
      this.timeTarget.textContent = formatClock(audio.currentTime)
    }
  }

  ended() {
    this.stateValue = "idle"
    this.progressTarget.style.width = "0%"
  }

  disconnect() {
    this.audioTarget.pause()
  }
}
